import { apiCallV2 } from "../../../utils/api";
import {
   SET_HAS_AVAILABLE_DEVICE,
   SET_IS_PLAYING,
   SET_VIDEO_DETAILS,
   SET_IS_PLAYING_CAST,
   SET_PLAYING_VIDEO_DETAILS,
   SET_AIRPLAY_AVAILABILITY,
   SET_AIRPLAY_CONNECTIVITY,
   SET_CAST_AVAILABILITY,
} from "./types";

export const CastSocketTakeAction = (props) => async (dispatch, getState) => {
   const { action } = props;

   if (action === "SHOW_CAST_BUTTON") {
      dispatch({
         type: SET_HAS_AVAILABLE_DEVICE,
         bool: true
      });
   } else if (action === "HIDE_CAST_BUTTON") {
      dispatch({
         type: SET_HAS_AVAILABLE_DEVICE,
         bool: false
      });
   } else if (action === "SHOW_ACTIVE_CAST_BUTTON") {
      dispatch({
         type: SET_IS_PLAYING_CAST,
         video: props.data?.video || null,
         bool: true
      });
   } else if (action === "HIDE_ACTIVE_CAST_BUTTON") {
      dispatch({
         type: SET_IS_PLAYING_CAST,
         bool: false
      });
   }

}


export const SetHasAvailableDevice = (bool) => async (dispatch, getState) => {
   dispatch({
      type: SET_HAS_AVAILABLE_DEVICE,
      bool: bool
   });
}

export const SetIsPlaying = (bool) => async (dispatch, getState) => {
   dispatch({
      type: SET_IS_PLAYING,
      bool: bool
   });
}

export const SetIsPlayingCast = (bool) => async (dispatch, getState) => {
   dispatch({
      type: SET_IS_PLAYING_CAST,
      bool: bool
   });
}

export const SetVideoDetails = (video) => async (dispatch, getState) => {
   dispatch({
      type: SET_VIDEO_DETAILS,
      details: { ...video }
   });
}


export const SendCastDetails2 = (connect = false, watchedTime = null) => async (dispatch, getState) => {

   const { video } = getState().Cast.native;

   let ext = video?.rawUrl?.split(".") || [];
   ext = ext[ext.length - 1];
   ext = ext.split("?")[0];

   try {

      if (!connect) {
         dispatch({
            type: SET_PLAYING_VIDEO_DETAILS,
            details: { ...video }
         });
      }


      const res = await apiCallV2(
         "POST",
         "toggle-cast-dialog",
         {
            video: {
               mediaInfo: {
                  contentUrl: connect ? "" : video?.rawUrl,
                  contentType: 'video/' + (ext || ""),
                  metadata: {
                     images: [
                        {
                           url: video?.thumbnail,
                        },
                     ],
                     video_id: video?.id,
                     vimeo: video?.video_id,
                     title: video?.title,
                     subtitle: video?.description,
                     studio: "Indi",
                     type: 'movie',
                  },
                  streamDuration: video?.video_time, // seconds
               },
               startTime: watchedTime || video?.startTime, // seconds}
               indiMaterialType: video?.indiMaterialType,
            },
         },
         localStorage.getItem("access-token"),
      );



      if (res.status == 200) {

      }
   } catch (err) {
   }

}

export const SendCastDetails = (connect = false, watchedTime = null) => async (dispatch, getState) => {
   const { video } = getState().Cast.native;
   let ext = video?.rawUrl?.split(".") || [];

   try {
      if (!connect) {
         dispatch({
            type: SET_PLAYING_VIDEO_DETAILS,
            details: { ...video }
         });
      }

      const res = await apiCallV2(
         "POST",
         "toggle-cast-dialog",
         {
            video: {
               mediaInfo: {
                  contentUrl: connect ? "" : video?.rawUrl,
                  contentType: 'video/' + (ext[ext.length - 1] || ""),
                  metadata: {
                     images: [
                        {
                           url: video?.thumbnail,
                        },
                     ],
                     video_id: video?.id,
                     vimeo: video?.video_id,
                     title: video?.title,
                     subtitle: video?.description,
                     studio: "Indi",
                     type: 'movie',
                  },
                  streamDuration: video?.video_time, // seconds
               },
               startTime: watchedTime, // seconds}
               indiMaterialType: video?.indiMaterialType,
            },
         },
         localStorage.getItem("access-token"),
      );



      if (res.status == 200) {

      }
   } catch (err) {
   }

}

export const CastDeviceCheck = () => async (dispatch, getState) => {


   const res = await apiCallV2(
      "POST",
      "cast-device-check",
      {},
      localStorage.getItem("access-token"),
   );


   if (res.status == 200) {

   }

}

export const UpdateAirplayAvailability = (bool) => async (dispatch, getState) => {
   dispatch({
      type: SET_AIRPLAY_AVAILABILITY,
      bool: bool
   });
}

export const ConnectAirplay = () => async (dispatch, getState) => {
   const res = await apiCallV2(
      "POST",
      "cast-device-check",
      {},
      localStorage.getItem("access-token"),
   );


   if (res.status == 200) {

   }
}

export const UpdateAirplayConnectivity = (bool) => async (dispatch, getState) => {
   dispatch({
      type: SET_AIRPLAY_CONNECTIVITY,
      bool: bool
   });
}

export const UpdateCastAvailability = (bool) => async (dispatch, getState) => {
   dispatch({
      type: SET_CAST_AVAILABILITY,
      bool: bool
   });
}